import { event } from '@uhg-abyss/web/tools/event';
import { usercache } from '../../tools/usercache';
import { getPayersRequest } from './requests';
import { payerEvent } from './events';

export const getPayersSaga = async ({ action }) => {
  let data = await getPayersRequest(action.payload);
  if (usercache.get('isIntakeUser')) {
    data = data.filter((payer) => payer.id === '87726');
  }

  return data;
};

export const setPayerSaga = async ({ action }) => {
  event.setData(payerEvent());
  await event.setData(payerEvent(action.payload));
};
